export const questionnairesSearchApiEndpoint = 'questionnaires/search';
export const questionnairesApiEndpoint = 'questionnaires';
export const surveysApiEndPoint = 'surveys';
export const questionnairesPublicApiEndpoint = 'public/questionnaires';
export const surveyDesignPThemePatchApiEndpoint = 'questionnaires/surveyTemplate';
export const surveyExportAsPDF = 'export/exportPDF';
export const surveyExportAsISF = 'export/exportISF';
export const surveyImportAsISF = 'export/getISF';
export const importSurveyFromISF = 'export/importISFQuestionnaire';
